import { customElement } from "lit/decorators.js";
import { OlLayer } from "./ol-layer";
import TileLayer from "ol/layer/Tile";
import { OSM } from "ol/source";


@customElement("ol-osm-tilelayer")
export class OlTileLayer extends OlLayer<TileLayer> {

    protected createLayer(): TileLayer<OSM> {
        return new TileLayer({
            source: new OSM(),
            visible: this.visible,
            opacity: this.opacity,
            zIndex: this.zIndex,
            minZoom: this.minZoom,
            maxZoom: this.maxZoom,
        });
    }

}